import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";

export default function Stats({ stats }) {
  const { t } = useTranslation();
  return (
    <section className="py-24 bg-gradient-to-r from-primary to-primary text-white px-4">
      <motion.h2
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        className="text-3xl font-semibold text-center mb-12"
      >
        {t("statsSection.title")}
      </motion.h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto justify-items-center">
        {stats.map((stat, idx) => {
          const Icon = Icons[stat.icon];
          return (
            <motion.div
              key={idx}
              whileInView={{ scale: 1 }}
              initial={{ scale: 0.8 }}
              viewport={{ once: true }}
              transition={{ duration: 1.5, delay: idx * 0.3 }}
              className="text-center"
            >
              <Icon className="w-10 h-10 mx-auto mb-3 text-white/80" />
              <CountUp
                start={0}
                end={stat.end}
                suffix={stat.suffix}
                duration={3}
                enableScrollSpy
                scrollSpyOnce
                className="text-4xl font-bold"
              />
              <p className="mt-1 text-lg">{stat.label}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
